import { Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { TfaComponent } from './auth/tfa/tfa.component';
import { AdminComponent } from './admin/admin.component';
import { CreateUserComponent } from './admin/create-user/create-user.component';
import { UserListComponent } from './admin/user-list/user-list.component';
import { AcceptComponent } from './accept/accept.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { PasswordResetResultComponent } from './auth/password-reset-result/password-reset-result.component';
import { ResetTokenComponent } from './auth/reset-token/reset-token.component';
import { SourceComponent } from './admin/source/source.component';
import { TestManagerComponent } from './test-manager/test-manager.component';
import { NewrequestComponent } from './requestform/newrequest/newrequest.component';
import { RequestDetailsComponent } from './requestform/request-details/request-details.component';
import { RequestsListComponent } from './requestform/requests-list/requests-list.component';
import { ResultListComponent } from './results/result-list/result-list.component';
import { ResultDetailsComponent } from './results/result-details/result-details.component';
import { CumulativeComponent } from './results/result-cumulative/result-cumulative.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';

export const routes: Routes = [
  {
    path: 'Admin', component: AdminComponent,
    children: [
      { path: 'users', component: UserListComponent },
      { path: 'createUser', component: CreateUserComponent },
      { path: 'editUser', component: CreateUserComponent },
    ]
  },
  {
    path: 'manage', component: TestManagerComponent,
    children: [
      { path: 'request', component: NewrequestComponent },
      { path: 'result-list', component: ResultListComponent },
      { path: 'result-details', component: ResultDetailsComponent },
      { path: 'request-list', component: RequestsListComponent },
      { path: 'request-details', component: RequestDetailsComponent },
      { path: 'change-password', component: ChangePasswordComponent },
      { path: 'cumul', component: CumulativeComponent }
    ]
  },
  {
    path: '', redirectTo: 'manage', pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'tfa', component: TfaComponent
  },
  {
    path: 'accept', component: AcceptComponent
  },
  {
    path: 'password-reset', component: PasswordResetComponent
  },
  {
    path: 'password-reset-result', component: PasswordResetResultComponent
  },
  {
    path: 'reset', component: ResetTokenComponent
  },
  {
    path: 'Source', component: SourceComponent
  }
];
